import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';

const apiPrefix = '/si/v1/';

const routes = {
    shippingInstructionRoute: () => apiPrefix + `shipping-instructions`,
    submitShippingInstruction: () => apiPrefix + `shipping-instructions-submit`,
    getContainerSubTypes: () => apiPrefix + `container-types`,
    userContactRoute: () => apiPrefix + `user-contact`,
    getCommodities: () => apiPrefix + `commodities`,
    getPackagesKind: () => apiPrefix + `type-of-packages`,
    getUserContactByContactId: (userContactId: any) => apiPrefix + `user-contact/${userContactId}`,
    getCountries: () => apiPrefix + `countries`,
    deleteSIDocumentBySIDocId: (siDocId: any) => apiPrefix + `si-documents/delete/${siDocId}`,
    deleteAllSIDocuments: () => `si-documents/delete-all`,
    siDocument: () => apiPrefix + `si-documents`,
    siContainerDocuments: () => apiPrefix + `si-container-documents`
};

@Injectable({
    providedIn: 'root'
})
export class ShipmentInstructionService {

    constructor(private http: HttpClient) {
    }

    getShipmentInstructionsByBookingId(bookingId: string) {
        const $shipmentInstruction: Observable<any> = this.http
            .get(routes.shippingInstructionRoute(), {
                params: {
                    bookingId
                }
            }).pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $shipmentInstruction;
    }

    getContainerSubTypes() {
        const $containerSubTypes: Observable<any> = this.http
            .get(routes.getContainerSubTypes())
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $containerSubTypes;
    }

    getUserContacts(role: string) {
        const $userContacts: Observable<any> = this.http
            .get(routes.userContactRoute(),
                {
                    params: {
                        role
                    }
                })
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $userContacts;
    }

    saveUserContactBasedOnRole(role: string, addressPayload: any) {
        const $userContact: Observable<any> = this.http
            .post(routes.userContactRoute(), addressPayload, {
                params: {
                    role
                }
            }).pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $userContact;
    }

    updateSelectedUserContact(userContactVO: any) {
        const $userContact: Observable<any> = this.http
            .put(routes.userContactRoute(), userContactVO).pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $userContact;
    }

    saveDraftSI(bookingId: string, siPayload: any) {
        const $shippingInstruction: Observable<any> = this.http
            .put(routes.shippingInstructionRoute(), siPayload, {
                params: {
                    bookingId
                }
            })
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $shippingInstruction;
    }

    updateDraftSI(bookingId: string, siPayload: any) {
        const $shippingInstruction: Observable<any> = this.http
            .put(routes.shippingInstructionRoute(), siPayload, {
                params: {
                    bookingId
                }
            })
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $shippingInstruction;
    }

    submitSI(bookingId: string, siPayload: any) {
        const $shippingInstruction: Observable<any> = this.http
            .post(routes.submitShippingInstruction(), siPayload, {
                params: {
                    bookingId
                }
            })
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $shippingInstruction;
    }

    // getAllUploadDocsBasedOnBookingId(bookingId: string) {
    //     const $containerDocs: Observable<any> = this.http
    //         .get(routes.containerDocumentRoute(), {
    //             params: {
    //                 bookingId,
    //             }
    //         })
    //         .pipe(
    //             map(
    //                 (x) => {
    //                     return x as any;
    //                 }
    //             )
    //         );
    //     return $containerDocs;
    // }

    uploadShippingInstructionContainerDocuments(documentTypeId: any, bookingId: any, multipartFile: any, shipUnitId: any) {
        const formData = new FormData();
        formData.append('multipartFile', multipartFile);
        const $siDocs: Observable<any> = this.http
            .post(routes.siContainerDocuments(), formData, {
                params: {
                    documentTypeId,
                    bookingId,
                    shipUnitId
                }
            })
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $siDocs;
    }

    // updateDocumentByDocId(containerDocId: any, multipartFile: any) {
    //     const formData = new FormData();
    //     formData.append('containerDocId', containerDocId);
    //     formData.append('multipartFile', multipartFile);
    //     const $containerRelatedDoc: Observable<any> = this.http
    //         .put(routes.containerDocumentRoute(), formData)
    //         .pipe(
    //             map(
    //                 (x) => {
    //                     return x as any;
    //                 }
    //             )
    //         );
    //     return $containerRelatedDoc;
    // }

    uploadSIDocuments(documentTypeId: any, bookingId: any, multipartFiles: any) {
        const formData = new FormData();
        multipartFiles?.map((x: any) => {
            formData.append('multipartFiles', x);
        });
        const $siRelatedDoc: Observable<any> = this.http
            .post(routes.siDocument(), formData, {
                params: {
                    documentTypeId,
                    bookingId
                }
            })
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $siRelatedDoc;
    }

    getCommodities(prefix: string) {
        const $commodities: Observable<any> = this.http
            .get(routes.getCommodities(), {
                params: {
                    prefix,
                }
            })
            .pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $commodities;
    }

    getKindOfPackages() {
        const $packages: Observable<any> = this.http
            .get(routes.getPackagesKind())
            .pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $packages;
    }

    getUserContactById(userContactId: any) {
        const $userContact: Observable<any> = this.http
            .get(routes.getUserContactByContactId(userContactId))
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $userContact;
    }

    getCountries() {
        const $countries: Observable<any> = this.http
            .get(routes.getCountries())
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $countries;
    }

    deleteSIDocumentBySIDocId(siDocId: any) {
        const $siDoc: Observable<any> = this.http
            .delete(routes.deleteSIDocumentBySIDocId(siDocId), {
                responseType: 'text'
            })
            .pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $siDoc;
    }
}
